import React from 'react';
import { Helmet } from 'react-helmet-async';

function Terms() {
	return (
		<section className="section">
			<div className="container">
				<Helmet>
					<title>Terms of Service • Appex Connect Hub</title>
				</Helmet>
				<h2>Terms of Service</h2>
				<p className="helper">
					Appex Connect Hub provides marketing and referral services operated by APEX SPECIALTY CONTRACTING LLC.
					We do not provide loans or make credit decisions. By using this website, you agree not to misuse the
					site, to provide accurate information, and to use our contact channels in accordance with our SMS Policy.
				</p>
			</div>
		</section>
	);
}

export default Terms;


